export const STATSIG_CLIENT_KEY = import.meta.env
  .VITE_STATSIG_CLIENT_KEY as string;

export const STATSIG_GATE = {
  ENABLE_SESSION_REPLAY: 'enable-session-replay',
  DECLINE_UI_ACTIONS: 'enable_decline_ui_actions',
  PRICE_CALLOUT: 'price_callout_ppui',
  CHECKOUT_Q3_DESIGN_ENHANCEMENTS_KSA: 'checkout_q3_design_enhancements_ksa',
} as const;

export type StatsigGate = (typeof STATSIG_GATE)[keyof typeof STATSIG_GATE];

export const STATSIG_EXPERIMENT = {
  PAYMENT_PLAN_HYPOTHESIS: 'payment_plan_hypothesis',
} as const;

export const STATSIG_VARIANT = {
  KEY: 'Variant',
  DEFAULT: 'Default',
  NEO: 'Neo',
} as const;
